module.exports = __webpack_public_path__ + "media/images/flags/4x3/arm-6291e2878eeffc4327f1038dd1ce9a10.svg";